import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import Wordmark from './Wordmark';
import './Footer.scss';

export default function Footer() {
  const { t } = useLocale();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container-x footer__inner">
        <div className="footer__brand">
          <Wordmark size={36} />
          <p className="footer__tagline">{t('footer.tagline')}</p>
        </div>

        <div className="footer__cols">
          <div className="footer__col">
            <span className="footer__heading">{t('footer.product')}</span>
            <a href="#how">{t('nav.how')}</a>
            <a href="#more">{t('nav.more')}</a>
            <a href="#who">{t('nav.who')}</a>
            <Link to="/login">{t('nav.login')}</Link>
          </div>
          <div className="footer__col">
            <span className="footer__heading">{t('footer.company')}</span>
            <a href="https://outfino.io" target="_blank" rel="noreferrer">
              outfino.io
            </a>
          </div>
          <div className="footer__col">
            <span className="footer__heading">{t('footer.legal')}</span>
            <a href="https://outfino.io" target="_blank" rel="noreferrer">
              {t('footer.privacy')}
            </a>
            <a href="https://outfino.io" target="_blank" rel="noreferrer">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>

      <div className="container-x footer__bottom">
        © {year} Outfino. {t('footer.rights')}
      </div>
    </footer>
  );
}
